import get from 'lodash/get';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import {formDataManager} from 'hoc/formDataManager';
import RevokeAmountOfPointsModal from './RevokeAmountOfPointsModal';
import config from './revokeAmountOfPointsConfig';
import {submitRevokeAmountOfPointsAction, endRevokeAmountOfPointsAction} from '../../../actions';

const mapStateToProps = state => {
  const {revokingAmountOfPoints, revokingAmountOfPointsSubmitted, currentUserId, currentUser} = state.userManagement;
  return {
    userId: currentUserId,
    email: get(currentUser, 'email', null),
    modalOpen: revokingAmountOfPoints,
    revoking: revokingAmountOfPointsSubmitted
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  revokeAmountOfPoints: submitRevokeAmountOfPointsAction,
  handleClose: endRevokeAmountOfPointsAction
}, dispatch);

const RevokeAmountOfPointsModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSaveData: props => data => props.revokeAmountOfPoints(Number(props.userId), Number(data.amount), data.reason)
  }),
  formDataManager({amount: '', reason: ''}, config)
)(RevokeAmountOfPointsModal);

export default RevokeAmountOfPointsModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/RevokeAmountOfPointsModal/RevokeAmountOfPointsModalContainer.js